<template>
  <div>
    <DevicesPageReact />
  </div>
</template>

<script>
  import DevicesPageReact from '@/components/blocks/reactComponents/DevicesPage.vue';

  export default {
    name: 'DevicesPage',

    components: {
      DevicesPageReact,
    },
  };
</script>
